import { getQueryString, useRouter } from '@framework/router';
import Select, { ISelectOption } from '@creditflowresearch/uilib/Select';
import { TABS } from './constants';

const options: ISelectOption[] = Object.values(TABS).map((tab) => ({ label: tab.title, value: tab.path }));

const LeagueTableTabSelect = () => {
  const { query: { products, regions, q }, asPath, push } = useRouter();

  const selectedOption = options.find((opt) => asPath.includes(opt.value as string)) || options[0];

  const handleChange = (option: ISelectOption): void => {
    push(`${ option.value }?${ getQueryString({ products, regions, q }) }`);
  };

  return (
    <Select
      value={ selectedOption }
      options={ options }
      onChange={ handleChange }
      isSlim
      isNarrow
      isSearchable={ false }
      size="S"
      dataTest="leagueTableTabSelect"
    />
  );
};

export default LeagueTableTabSelect;
